/**
 * App
 *
 * Main application with routing.
 */

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout, ErrorBoundary } from './components';
import { ChatPage, ProfilePage, TimelinePage, AdminPage, RelationshipsPage } from './pages';
import './styles/globals.css';

function AppContent() {
  // Auth check is handled automatically by useAuth hook's useEffect
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<ChatPage />} />
        <Route path="/chat/:sessionUuid" element={<ChatPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/relationships" element={<RelationshipsPage />} />
        <Route path="/timeline" element={<TimelinePage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </Layout>
  );
}

export function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
